export default __webpack_public_path__ + "static/media/filter.5ad917c5.svg";